import React from "react";

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer__inner">
      <span>© {new Date().getFullYear()} Mücahit Tünel</span>
    </div>
  </footer>
);

export default Footer;
